import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getTransitionWithVariable } from '../../../../../redux_store';

const HeaderWidget = ({
  currentSurvey,
  assessmentStatus,
  getSurveyTypeName,
  handleLaunchSurvey,
  handleDeleteSurvey,
  handleDeactivateSurvey,
  handleRelaunchSurvey,
  handleArchiveSurvey,
  classes,
}) => {
  const { en: { instantSurvey } } = useSelector((state) => state.i18n);

  return (
    <div className={classes.header}>
      <div className={classes.headerContainer}>
        <div className={classes.headerInfo}>
          <div className={classes.titleRow}>
            <Typography className={classes.title}>
              {currentSurvey?.title || instantSurvey.mainTitle}
            </Typography>
            <span className={`${classes.statusIndicator} ${assessmentStatus}`}>
              {assessmentStatus === 'draft' && 'Draft'}
              {assessmentStatus === 'active' && 'Active'}
              {assessmentStatus === 'inactive' && 'Inactive'}
              {assessmentStatus === 'archived' && 'Archived'}
            </span>
          </div>
          <Typography className={classes.subtitle}>
            {getSurveyTypeName(currentSurvey?.surveyType)
              ? getTransitionWithVariable(instantSurvey.mainSubtitle, { surveyType: getSurveyTypeName(currentSurvey?.surveyType) })
              : instantSurvey.mainSubtitleNoType
            }
          </Typography>
        </div>

        {/* Status Control Buttons */}
        <div className={classes.headerActions}>
          {assessmentStatus === 'draft' && (
            <>
              <Button
                variant="contained"
                className={classes.launchButton}
                onClick={handleLaunchSurvey}
              >
                Launch
              </Button>
              <Button
                variant="contained"
                className={classes.deactivateButton}
                onClick={handleDeleteSurvey}
              >
                Delete
              </Button>
            </>
          )}
          {assessmentStatus === 'active' && (
            <Button
              variant="contained"
              className={classes.deactivateButton}
              onClick={handleDeactivateSurvey}
            >
              Deactivate
            </Button>
          )}
          {assessmentStatus === 'inactive' && (
            <>
              <Button
                variant="contained"
                className={classes.launchButton}
                onClick={handleRelaunchSurvey}
              >
                Relaunch
              </Button>
              <Button
                variant="contained"
                className={classes.deactivateButton}
                onClick={handleArchiveSurvey}
              >
                Archive
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderWidget;